import SetupDetail from './SetupDetail';

export default SetupDetail;



// WEBPACK FOOTER //
// ./src/components/admin/Setup/index.js